import { call, put, takeLatest } from 'redux-saga/effects';
import { assignDeliveryArrangedAgent } from '../../requests/assign_lead_request';
import { assignLeadDeliveryRequestedAgentSuccess, assignLeadDeliveryRequestedAgentFailure } from '../actions/assign_lead.actions';
import { ASSIGN_LEAD_DELIVERY_REQUESTED_AGENT } from '../constants/assign_lead.constants';
import { message_error, message_success } from '../../../../../components/Message';
import { getLeadDeliveryRequestedAgent } from '../../../Lead_profile/requests/get_lead_profile_request';

function* assignLeadDeliveryRequestedAgentRequest({ userId, leadId }) {
    const { result, msg, error } = yield call(assignDeliveryArrangedAgent, userId, leadId);
    if (result) {
        yield put({ type: 'GET_LEAD_HISTORY_REQ', leadId });
        const lead = yield call(getLeadDeliveryRequestedAgent, leadId);
        yield put(assignLeadDeliveryRequestedAgentSuccess(lead.options.ref_delivery_requested_assigned_to));
        message_success('Assigned successfully!');
    } else {
        yield put(assignLeadDeliveryRequestedAgentFailure(error));
        message_error(msg);
    }
}

export default function* assignLeadDeliveryRequestedAgentSaga() {
    yield takeLatest(ASSIGN_LEAD_DELIVERY_REQUESTED_AGENT, assignLeadDeliveryRequestedAgentRequest);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Manage_retail/redux/sagas/assign_lead_delivery_requested_agent.saga.js